import React, { Component } from 'react';
import { MetricItem } from '../../../domain/chart/ChartDomains';

class IndicatorChartComponent extends Component<Props> {
  public render() {
    const { values, metrics } = this.props;
    return (
      <div className={'flex flex-col w-full overflow-scroll  pt-8 pb-5 px-5'}>
        {values.map((v, index) => {
          const value = this.getDecimalValue(v.value);
          return (
            <div className={'flex shrink-0 h-full flex-col gap-y-5 text-primary items-center justify-center px-5 py-5'} key={index}>
              <p className={'text-5xl font-normal text-f-black-3 '}>{value}</p>
            </div>
          );
        })}
      </div>
    );
  }

  private getDecimalValue = (value: string | number) => {
    try {
      const result = Number.parseInt(String(value)).toLocaleString('en-US', {
        style: 'decimal',
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
      });
      return result;
    } catch (e) {
      return value;
    }
  };
}

interface Props {
  values: IndicatorChartData[];
  metrics: MetricItem[];
}

export interface IndicatorChartData {
  value: string | number;
  label: string;
}

export default IndicatorChartComponent;
